import { useEffect, useState } from 'react';
import {
    isBoolean,
    isArray,
    isEmpty,
    isString,
    compact,
    isPlainObject,
    set,
    get,
    indexOf
} from 'lodash'

export const REQUIRED_MESSAGE = 'This is required';

export function required (value, allValues) {
    if (isBoolean(value)) {
        return value ? null : REQUIRED_MESSAGE;
    }

    if (isArray(value)) {
        return isEmpty(value) ? REQUIRED_MESSAGE : null;
    }

    if (isString(value)) {
        return value.replace(/\s/g, '').length === 0 ? REQUIRED_MESSAGE : null;
    }

    return [null, undefined, '', false].indexOf(value) === -1 ? null : REQUIRED_MESSAGE;
}

const getObjectLength = group => {
    const values = Object.values(group);

    return compact(values).length;
};

export const oneRequired = fields => (value, allValues) => {
    let hasValues = false;

    Object.values(allValues).forEach(group => {
        if (isPlainObject(group)) {
             if (getObjectLength(group) === 3) {
                 hasValues = true;
             }
        }
    });
    
    return hasValues ? null : 'Please select at least one option';
};

export function email (value) {
    if (value) {
        const re = /\S+@\S+\.\S+/;

        return re.test(value) ? null : 'Please enter a valid email address';
    }
}

export function phone (value) {
    const re = new RegExp("^(((\\+44\\s?\\d{4}|\\(?0\\d{4}\\)?)\\s?\\d{3}\\s?\\d{3})|((\\+44\\s?\\d{3}|\\(?0\\d{3}\\)?)\\s?\\d{3}\\s?\\d{4})|((\\+44\\s?\\d{2}|\\(?0\\d{2}\\)?)\\s?\\d{4}\\s?\\d{4}))(\\s?\\#(\\d{4}|\\d{3}))?$");

    return re.test(value) ? null : 'Please enter a valid UK telephone number';
}

export function withValidation(WrappedComponent) {
    return function (props) {
        const [errorText, setErrorText] = useState(null)

        const onChangeHandler = (e) => {
            const { value } = e.target;
            const { allValues } = props;
            const newValues = set(allValues, props.name, value);
            let newErrorText = null;

            get(props, 'validations', []).find((validation) => {
                newErrorText = validation(value, newValues);
                return newErrorText;
            });

            props.handleChange(e, newErrorText);

            setErrorText(newErrorText)
        };

        useEffect(() => {
            if (props.validateOnRender) {
                onChangeHandler({
                    target: {
                        value: props.value
                    }
                });
            }
        }, [props])

        const { helperText, validations } = props;
        const errorTextDisplay = errorText ? errorText : helperText;

        return <WrappedComponent {...props} required={indexOf(validations, required) !== -1} handleChange={onChangeHandler} helperText={errorTextDisplay} showError={!!errorTextDisplay}/>
    }
};
